<div *nzModalTitle>Edit Project: {{ nzModalData.project.name }}</div>

<div>
  <nz-spin [nzSpinning]="loading">
    <form nz-form [formGroup]="projectForm">
      <nz-form-item class="floating-label">
        <nz-form-label nzRequired for="name">Name</nz-form-label>
        <nz-form-control nzErrorTip="Please enter a project name">
          <input formControlName="name" nz-input id="name" name="name" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="floating-label">
        <nz-form-label for="field">Field</nz-form-label>
        <nz-form-control nzErrorTip="Please select a field">
          <nz-select
            [compareWith]="compareFn"
            style="width: 100%"
            nzPlaceHolder="Please select a field"
            nzShowSearch
            formControlName="field"
            id="field"
            name="field"
            >
            @for (field of fields; track field) {
              <nz-option
                [nzLabel]="field.name"
                [nzValue]="field"
              ></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="floating-label">
        <nz-form-label for="description">Description</nz-form-label>
        <nz-form-control>
          <textarea
            nz-input
            placeholder="Project Description"
            [nzAutosize]="{ minRows: 3 }"
            formControlName="description"
            id="description"
            name="description"
          ></textarea></nz-form-control>
        </nz-form-item>
      </form>
    </nz-spin>
  </div>

  <div *nzModalFooter>
    <button
      [disabled]="loading || !this.projectForm.valid"
      nz-button
      nzType="primary"
      (click)="submit()"
      [nzLoading]="loading"
      >
      Submit
    </button>
    <button nz-button (click)="destroyModal()">Cancel</button>
  </div>